import styled from "styled-components";

const Img = styled.img`
    border-radius: 50px;
    background-color: red;
    width: 50px;
`;

export { Img }